import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ContactForm from "@/components/landing/ContactForm";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <motion.div
          className="footer-cta"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="footer-ar" aria-hidden="true">ٱقْتَرِب</div>
          <h2>Commence aujourd'hui,<br />un verset à la fois.</h2>
          <Link to="/guides" className="btn" data-testid="footer-cta-btn">
            Voir les guides
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <ContactForm />
        </motion.div>

        <div className="legal-links">
          <Link to="/contact#mentions-legales" data-testid="footer-mentions-link">Mentions légales</Link>
          <Link to="/contact#cgv" data-testid="footer-cgv-link">CGV</Link>
          <Link to="/contact#confidentialite" data-testid="footer-privacy-link">Politique de confidentialité</Link>
          <Link to="/contact#remboursement" data-testid="footer-refund-link">Politique de remboursement</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
